import styled from 'styled-components';
import { px2rem } from '../../../../stylesheets/tools';

const StyledEducationLibraryFilter = styled.section`
  .library-filter__grid {
    display: flex;
    flex-direction: column;
    gap: ${px2rem('40px')};
  }
`;

export default StyledEducationLibraryFilter;
